import { DATA_SETS_ENUM_TYPES } from 'constants/dataSets';

import type IUseValueChainColumnsParams from './interfaces/IUseValueChainColumnsParams';

const useValueChainColumns = ({
  enumData,
  boardColumnNamesData,
}: IUseValueChainColumnsParams) => {
  const handleGetDefaultColumn = (): string => {
    if (!enumData) {
      return '';
    }
    const valueChainSectionKey = DATA_SETS_ENUM_TYPES.valueChainSection;
    const valueChainSectionData = enumData[valueChainSectionKey];
    if (!Array.isArray(valueChainSectionData) || !valueChainSectionData.length) {
      return '';
    }
    const firstOption = valueChainSectionData[0] as { value: string };
    return firstOption.value;
  };

  const getColumnId = (name?: string) => {
    const currentNameColumn = boardColumnNamesData?.data?.find((column) => column?.columnName === name);
    return currentNameColumn?.columnId;
  };

  return {
    handleGetDefaultColumn,
    getColumnId,
  };
};

export default useValueChainColumns;
